import MaterialDivider from "../../../../__snowpack__/pkg/@mui/material/Divider.js";
import React from "react";
import Icon from "../../atoms/icon/icon.component.js";
import Unit from "../../atoms/unit/unit.component.js";
import {MergeUnitContent, MergeUnitDividerContainer} from "./merge-unit.styles.js";
import {makeStyles} from "../../../../__snowpack__/pkg/@mui/styles.js";
const useStyles = makeStyles({
  justify_content: {
    justifyContent: "space-around"
  }
});
function MergeUnit({
  source,
  destination
}) {
  const classes = useStyles();
  return /* @__PURE__ */ React.createElement(MergeUnitContent, null, /* @__PURE__ */ React.createElement(Unit, {
    mergeUnit: source
  }), /* @__PURE__ */ React.createElement(MergeUnitDividerContainer, {
    className: classes.justify_content
  }, /* @__PURE__ */ React.createElement(MaterialDivider, {
    orientation: "vertical"
  }), /* @__PURE__ */ React.createElement(Icon, null, "merge_type"), /* @__PURE__ */ React.createElement(MaterialDivider, {
    orientation: "vertical"
  })), /* @__PURE__ */ React.createElement(Unit, {
    mergeUnit: destination
  }));
}
export default /* @__PURE__ */ React.memo(MergeUnit);
